import Footer from '../home/components/Footer';
import PageSEO from '../../components/feature/PageSEO';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://arvakon.com';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <PageSEO
        title="Privacy Policy – Arvakon | Independent Technical Verification"
        description="Arvakon privacy policy. Learn how we collect, use, and protect information submitted through our technical inquiry and website services."
        keywords="Arvakon privacy policy, data protection, technical verification services"
        canonical={`${siteUrl}/privacy-policy`}
      />

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-8 py-5 flex items-center justify-between">
          <a href="/" className="text-dark-primary text-xl font-semibold tracking-tight">
            ARVAKON
          </a>
          <nav className="flex items-center gap-8">
            <a href="/" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Home</a>
            <a href="/services" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Services</a>
            <a href="/standards" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Standards</a>
            <a href="/projects" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Industry Applications</a>
            <a href="/about" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">About</a>
            <a href="/contact" className="text-sm text-slate-600 hover:text-dark-primary transition-colors">Contact</a>
          </nav>
        </div>
      </header>

      {/* Page Header */}
      <div className="pt-40 pb-20 px-8 bg-[#F8FAFC] border-b border-slate-200">
        <div className="max-w-4xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
            Legal
          </p>
          <h1 className="font-serif text-4xl text-dark-primary tracking-tight">
            Privacy Policy
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <main className="py-24 px-8">
        <div className="max-w-4xl mx-auto space-y-8">

          <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
            <p>
              Arvakon collects and processes limited business contact and project-related information submitted through the Technical Inquiry form. This may include company name, contact person details, email address, phone number, project location, industry sector, equipment category, applicable codes/standards, requested services, project timeline, and any additional technical information provided by the user.
            </p>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Purpose of Processing:
            </h2>
            <ul className="space-y-2 text-slate-600 text-[15px] leading-[1.85]">
              <li className="flex items-start gap-3">
                <span className="text-slate-400 mt-1">•</span>
                <span>To review and respond to technical inquiries</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-slate-400 mt-1">•</span>
                <span>To perform internal evaluation of service scope and feasibility</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-slate-400 mt-1">•</span>
                <span>To support procurement documentation and vendor onboarding requests when applicable</span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Data Retention:
            </h2>
            <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
              <p>
                Information is retained only as necessary to respond to the inquiry and maintain internal correspondence records, unless longer retention is required for legitimate business purposes or applicable legal obligations.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Data Sharing:
            </h2>
            <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
              <p>
                Arvakon does not sell personal data. Information may be shared internally and, where necessary, with authorized representatives involved in providing a response.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Security:
            </h2>
            <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
              <p>
                Arvakon applies reasonable administrative and technical measures to protect submitted information.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
              Contact:
            </h2>
            <div className="space-y-4 text-slate-600 text-[15px] leading-[1.85]">
              <p>
                For privacy-related requests, please contact Arvakon via the Contact page.
              </p>
            </div>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}